module.exports = __webpack_public_path__ + "static/media/carLoan.fff88512.svg";